<script>
import { typeTarget } from '@/stores.js';

let className = '';
export { className as class };
export let type;
export let click = (type) => (e) => {
  console.log('click type', type);
  e.preventDefault();
  $typeTarget = type;
}

</script>



<div
  class="type-icon {className}"
  data-type={type} title={type}
  on:click={click(type)}
/>


